var mobile_breakpoint = 992;
$(function () {    
    $(window).scroll( function() { update_product_cta_bar() } );
    function update_product_cta_bar () {
        if ( $(window).scrollTop() > $('#product_features_ghost').offset().top-$('.nav-container').outerHeight() ) {
            $('#product_features_ghost').height($('#product_features_menu_content').outerHeight()+30);
            $('#product_features_menu').css('margin-top', $('.nav-container').outerHeight());
            $('#product_features_menu').addClass('fixed-top');
        } else {
            $('#product_features_ghost').css('height', 0);
            $('#product_features_menu').css('margin-top', 0);
            $('#product_features_menu').removeClass('fixed-top');
        }
    }
  
    $('#product_features_current').click(function() {
        $('#product_features_options').slideToggle();
        $('#product_features_current .fa-angle-down').toggleClass('rotate180');
    });
    
    $('.product-features-option').click(function() {
        if ( !$(this).hasClass('active') ) {
            $('.product-features-option').removeClass('active');
            $(this).addClass('active');
            
            $('.product-section-content').slideUp();
            $('#'+$(this).attr('data-target')).slideDown();
            $('html, body').animate({scrollTop: $('#product_features_ghost').offset().top-$('.nav-container').height()}, 500);
            
            if ( $(window).width() < mobile_breakpoint ) {
                $('#product_features_options').slideUp();
                $('#product_features_current .active').text( $(this).text() );
                $('#product_features_current .fa-angle-down').removeClass('rotate180');
            }
        } else {
            $('html, body').animate({scrollTop: $('#product_features_ghost').offset().top-$('.nav-container').height()}, 500);
            
            if ( $(window).width() < mobile_breakpoint ) {
                $('#product_features_options').slideUp();
                $('#product_features_current .active').text( $(this).text() );
                $('#product_features_current .fa-angle-down').removeClass('rotate180');
            }
        }
    });
  
    // TURNTABLE
    function turntable_control() {
        var tab_breakpoint = mobile_breakpoint,
            document_width = $(document).width();
        if (tab_breakpoint < document_width) {
            // desktop
            $('#product_still_image, #product_turntable_close_btn, #product_turntable_open_btn').hide();
            $('#product_turntable_div').show();
            $('#product_turntable_wrapper').turntable();
        } else {
            // mobile
            $('#product_still_image, #product_turntable_close_btn, #product_turntable_open_btn').show();
            $('#product_turntable_div').hide();
        }
    }
    turntable_control();
    $('#product_turntable_open_btn').click(function (e) {
        e.preventDefault();
        $('#product_turntable_div, #product_turntable_close_btn').show();
        $('#product_still_image').hide();
        $('#product_turntable_wrapper').turntable();
        $('body').addClass('overflow-hidden');
    });
    $('#product_turntable_close_btn').click(function (e) {
        e.preventDefault();
        $('#product_turntable_div').hide();
        $('#product_still_image').show();
        $('body').removeClass('overflow-hidden');
    });
    $(window).resize(function() {
        //collection_adjust_tab();
        turntable_control();
        $('body').removeClass('overflow-hidden');
        $('.footer-collection-margin').css('height', $('#footer_cart').outerHeight());
        $('.zopim, #proonto-widget').css('transform', 'translateY(-'+$('#footer_cart').outerHeight()+'px)');
    });
  
    // POPUP IMAGES
    $('.single-popup').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        image: {
            verticalFit: true
        }
    });
  
  	// SCROLL WITH SCREEN
    if ( $(document).width() >= mobile_breakpoint) {
        $(document).scroll(function() {
          	var offsetTurntable = 30;
          	var paddingTurntable = ( $(window).height() - $('#product_turntable_wrapper').height() - $('#product_turntable_swipe').height() - $('#product_carousel_wrapper').outerHeight(true) ) / 2;
          	var paddingLimit = $('.product-sidebar').outerHeight(true) - $('#product_turntable_wrapper').height() - $('#product_turntable_swipe').height() - $('#product_carousel_wrapper').outerHeight(true) - $('.nav-container').height() - 50;
          	if ( $(document).scrollTop() >= 30 ) {
          	    if ( paddingLimit > paddingTurntable + 20 - $('.nav-container').height() + $(document).scrollTop() ) {
          	        offsetTurntable = paddingTurntable + 20 - $('.nav-container').height() + $(document).scrollTop();
          	    } else {
          	        offsetTurntable = paddingLimit;
          	    }
          	}
        	$('#product_turntable_div').css('margin-top', offsetTurntable);
        });
    }
});